document.addEventListener("DOMContentLoaded", function () {

  const searchInput = document.getElementById("searchInput");
  const glossaryItems = document.querySelectorAll(".term-item");
  const glossarySections = document.querySelectorAll(".glossary-section");
  const noResults = document.getElementById("noResults");

  // =========================
  // SEARCH FUNCTION
  // =========================

function filterGlossary(query) {

  let hasResults = false;

  query = query.toLowerCase().trim();

  glossaryItems.forEach(item => {

    const titleElement = item.querySelector("h3");
    const descElement = item.querySelector(".term-description");

    const titleText = titleElement.textContent;

    // Store original title once
    if (
      titleElement &&
      !titleElement.dataset.original
    ) {
      titleElement.dataset.original =
        titleElement.innerHTML;
    }

    // Restore original title
    titleElement.innerHTML =
      titleElement.dataset.original;

    // SEARCH ONLY TITLE
    const titleOnly =
      titleText.toLowerCase();

    if (titleOnly.includes(query)) {

      item.style.display = "";
      hasResults = true;

      if (query.length > 0) {

        const regex = new RegExp(
          "(" +
          query.replace(
            /[.*+?^${}()|[\]\\]/g,
            '\\$&'
          ) +
          ")",
          "gi"
        );

        // Highlight ONLY title
        titleElement.innerHTML =
          titleText.replace(
            regex,
            '<mark class="search-highlight">$1</mark>'
          );

      }

    } else {

      item.style.display = "none";

    }

  });

  // Show/hide sections
  glossarySections.forEach(section => {

    const visibleItems = Array.from(
      section.querySelectorAll(".term-item")
    ).filter(
      item => item.style.display !== "none"
    );

    section.style.display =
      visibleItems.length > 0
        ? ""
        : "none";

  });

  // No results
  if (noResults) {

    noResults.style.display =
      hasResults
        ? "none"
        : "block";

  }

}

  // =========================
  // INPUT SEARCH
  // =========================

  if (searchInput) {

    searchInput.addEventListener("input", function () {

      const query = this.value;

if (query.trim() === "") {

  glossaryItems.forEach(item => {

    item.style.display = "";

    const titleElement =
      item.querySelector("h3");

    const descElement =
      item.querySelector(".term-description");

    // Restore original title
    if (
      titleElement &&
      titleElement.dataset.original
    ) {

      titleElement.innerHTML =
        titleElement.dataset.original;

    }

    // Restore original description
    if (
      descElement &&
      descElement.dataset.original
    ) {

      descElement.innerHTML =
        descElement.dataset.original;

    }

  });

  glossarySections.forEach(section => {
    section.style.display = "";
  });

  if (noResults) {
    noResults.style.display = "none";
  }

  return;
}

      filterGlossary(query);

    });

  }

  // =========================
  // RANDOM TERM
  // =========================

  window.randomTerm = function () {

    const visibleItems = Array.from(glossaryItems)
      .filter(item => item.style.display !== "none");

    if (!visibleItems.length) return;

    const randomItem =
      visibleItems[
        Math.floor(Math.random() * visibleItems.length)
      ];

    randomItem.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });

    randomItem.classList.add("highlighted");

    setTimeout(() => {
      randomItem.classList.remove("highlighted");
    }, 2000);

  };

  // =========================
  // QUICK CALCULATOR
  // =========================

  window.quickCalc = function () {

    const areaField =
      document.getElementById("calcArea");

    const productField =
      document.getElementById("calcProduct");

    const totalField =
      document.getElementById("calcTotal");

    const detailField =
      document.getElementById("calcDetail");

    if (
      !areaField ||
      !productField ||
      !totalField ||
      !detailField
    ) {
      return;
    }

    const area =
      parseFloat(areaField.value) || 0;

    const values =
      productField.value.split("|");

    const price =
      parseFloat(values[0]) || 0;

    const waste =
      parseFloat(values[1]) || 0;

    const totalArea =
      area + (area * waste / 100);

    const total =
      totalArea * price;

    totalField.innerHTML =
      Math.round(total) + " €";

    detailField.innerHTML =
      totalArea.toFixed(1) +
      " m² (inkl. " +
      waste +
      "% Verschnitt) × " +
      price.toFixed(2) +
      " €";

  };

  // =========================
  // AUTO CALCULATOR UPDATE
  // =========================

  const calcArea =
    document.getElementById("calcArea");

  const calcProduct =
    document.getElementById("calcProduct");

  if (calcArea) {
    calcArea.addEventListener("input", quickCalc);
  }

  if (calcProduct) {
    calcProduct.addEventListener("change", quickCalc);
  }

  // Initial calculation
  quickCalc();

  

});